export const HRTeamsData = [
    {
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-10-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28-06-2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-08-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Design`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF11125",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Sales`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF9999",
      fName: "Ram",
      designation:'Digital Marketing',
      dept: `Marketing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF2222",
      fName: "Dom",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },{
      id: "KCVF112L",
      fName: "John Doe",
      designation:'Digital Marketing',
      dept: `Testing`,
      type: '6 months',
      joinDate: '28-06-2022',
      deadline:'28.10.2022',
      shift: 'Shift A',
      team:'Digital marketing',
      contact : 9855254618
    },
  ]